import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Paprika, PaprikaTypography, PaprikaSpacing } from '../../styles/theme';
import { useTranslation } from 'react-i18next';

interface MetaRowProps {
  prepTime?: number;
  totalTime?: number;
}

const formatTime = (minutes: number): string => {
  if (minutes < 60) return `${minutes}m`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
};

export const MetaRow: React.FC<MetaRowProps> = ({ prepTime, totalTime }) => {
  const { t } = useTranslation();
  const stats: { label: string; value: string }[] = [];

  if (prepTime && prepTime > 0) {
    stats.push({ label: t('common.prep'), value: formatTime(prepTime) });
  }
  if (totalTime && totalTime > 0) {
    stats.push({ label: t('common.total'), value: formatTime(totalTime) });
  }

  if (stats.length === 0) return null;

  return (
    <View style={styles.row}>
      {stats.map((stat, i) => (
        <React.Fragment key={stat.label}>
          <View style={styles.stat}>
            <View style={styles.iconPill}>
              <Feather name="clock" size={13} color={Paprika.accent} />
            </View>
            <View style={styles.textBlock}>
              <Text style={styles.label}>{stat.label}</Text>
              <Text style={styles.value}>{stat.value}</Text>
            </View>
          </View>
        </React.Fragment>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: PaprikaSpacing.lg,
    marginBottom: PaprikaSpacing.md,
  },
  stat: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: PaprikaSpacing.sm,
  },
  iconPill: {
    width: 34,
    height: 34,
    borderRadius: 10,
    backgroundColor: Paprika.surfaceLow,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textBlock: {
    gap: 1,
  },
  label: {
    ...PaprikaTypography.labelSmall,
    color: Paprika.textMuted,
    letterSpacing: 0.5,
  },
  value: {
    ...PaprikaTypography.titleMedium,
    color: Paprika.textPrimary,
  },
});

export default MetaRow;
